import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { roleActions } from '../../../application/actions/role';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// GETALL
export function* getAllFetch() {
    yield put(roleActions.conexionGetAll({connection:true}));
    try {
        const url = `role`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(roleActions.getAll({data}));
    } catch (err) {
        yield put(roleActions.errorGetAll({error:true, message:err.message}));
    } finally {
        yield put(roleActions.conexionGetAll({connection:false}));
    }
}

export function* watchFetchRole() {
    yield takeLatest(roleActionsSaga.getAll.type,  getAllFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchRole);
}


const getAll = createAction('roleSaga/getAll');

export const roleActionsSaga = {
    getAll
};
